import styles from "./MinorHeader.module.css";
import { useTheme } from "../ThemeContext";

export default function MinorHeader({
  header,
  description1,
  description2,
  isXs,
  isSm,
}) {
  const headerClass = `${styles.minorHeader} mt-5`;
  const { s, toggleTheme } = useTheme();

  const descriptionClass = `${styles.minorDescr} mt-3 mt-lg-4`;
  return (
    <>
      <h4 className={headerClass} style={s.minorHeader}>
        {header}
      </h4>

      <p className={descriptionClass} style={s.minorDescr}>
        {isXs || isSm ? (
          [description1, description2].join("")
        ) : (
          <>
            {description1}
            {description2 && (
              <>
                <br />
                {description2}
              </>
            )}
          </>
        )}
      </p>
    </>
  );
}
